import VuexPersistence from 'vuex-persist';

export default ({ store }) => {
  console.log('Nuxt ready');
  new VuexPersistence({
    /* your options */
    reducer: (state) => ({ auth: state.auth }),
  }).plugin(store);
};
